import { type FC } from "react";
import { RankingLabel } from "@userFrontend/features/promotion/components/RankingLabel";
import { RankingText } from "@userFrontend/features/promotion/components/RankingText";
import { type RankingResultProps } from "../../types/type";
import * as styles from "./styles.css";

export const RankingResult: FC<RankingResultProps> = ({
  rank,
  title,
  rankNum,
  total,
  labelText,
}) => {
  return (
    <div className={styles.container({ rank })}>
      <p className={styles.title}>{title}</p>
      <RankingText rank={rank} rankNum={rankNum} total={total} />
      {labelText && rank && <RankingLabel rank={rank}>{labelText}</RankingLabel>}
    </div>
  );
};
